module.exports = __webpack_public_path__ + "img/cs1.86cb5b6e.png";